import {IAssistantActionHandler, IAssistantInitialState} from './interfaces';
import {
  ASSISTANT_DIALOGUE_ASSIGNED,
  ASSISTANT_DIALOGUE_CLEARED,
  ASSISTANT_DIALOGUE_REQUESTED,
  ASSISTANT_DIALOGUE_UNASSIGNED,
  ASSISTANT_DIALOGUE_UNAVAILABLE,
  AssistantActionsType
} from './actions';

const AssistantInitialState: IAssistantInitialState = {
  status: 'idle',
  assistant: null
};

const setRequested = ({state}: IAssistantActionHandler): IAssistantInitialState => {
  return {
    ...state,
    status: 'loading',
    assistant: null
  };
};

const setAssigned = ({state, payload}: IAssistantActionHandler): IAssistantInitialState => {
  return {
    ...state,
    status: 'assigned',
    assistant: payload
  };
};

const setUnassigned = ({state}: IAssistantActionHandler): IAssistantInitialState => {
  return {
    ...state,
    status: 'unassigned',
    assistant: null
  };
};

const setUnavailable = ({state}: IAssistantActionHandler): IAssistantInitialState => {
  return {
    ...state,
    status: 'unavailable',
    assistant: null
  };
};

const setCleared = (): IAssistantInitialState => {
  return {...AssistantInitialState};
};

const assistantReducerHandlers = new Map([
  [ASSISTANT_DIALOGUE_REQUESTED, setRequested],
  [ASSISTANT_DIALOGUE_ASSIGNED, setAssigned],
  [ASSISTANT_DIALOGUE_UNASSIGNED, setUnassigned],
  [ASSISTANT_DIALOGUE_UNAVAILABLE, setUnavailable],
  [ASSISTANT_DIALOGUE_CLEARED, setCleared]
]);

const assistantReducer = (state = AssistantInitialState, action: AssistantActionsType): IAssistantInitialState => {
  const handler = assistantReducerHandlers.get(action.type);

  return (handler && {
    ...handler(<IAssistantActionHandler>{
      state,
      payload: action.payload
    })
  }) || {...state};
};

export default assistantReducer;
